module.exports = __webpack_public_path__ + "media/images/logo-2be9bd6911eda16b5a4f097b672ffeb3.png";